import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "loading-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneOrderDetails = _resolveComponent("VabeneOrderDetails");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('pages.orderDetails')
        }, null, 8, ["PageTitle"]),
        (_ctx.localCommandeID)
            ? (_openBlock(), _createBlock(_component_VabeneOrderDetails, {
                key: 0,
                commandeID: _ctx.localCommandeID
            }, null, 8, ["commandeID"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.loading')), 1)
            ]))
    ], 64));
}
